// libs
import React from 'react';

import { useTranslation } from '@lyearn/i18n';
// components
import { Box } from '@lyearn/ui';

import FormContainer from './FormContainer';
import { EditorProps } from './types';

function Editor({ data, methods, state, formRef }: EditorProps) {
  useTranslation(['Exercise']);

  return (
    <Box className="h-full w-full">
      <FormContainer data={data} formRef={formRef} methods={methods} state={state} />
    </Box>
  );
}

export default Editor;
